import React, { Component } from 'react';
import Header from './components/Header'
import KeyFeatures from './components/KeyFeatures'
import WalletGroup from './components/WalletGroup'

import './style.css'
import { header, lastPart, contentsWallet, contentsIntegrate, collabIntegrate, keyFeature } from './components/data';

import Simplify from './components/Simplify';


class FinancialInstitution extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Header content={header.financialInstitution} />

        <WalletGroup contents={[contentsWallet.financialInstitution, contentsIntegrate.financialInstitution, collabIntegrate.financialInstitution]} />

        <KeyFeatures data={keyFeature.financialInstitution} />

        <Simplify content={lastPart.financialInstitution} />
      </div>
    );
  };
}

export default FinancialInstitution;
